import { Button } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";
import type { ReactNode } from "react";

type Props = {
  onClick?: () => void;
  isDisabled?: boolean;
  /** Overrides the default "Edit" label (e.g. "Verify") while keeping the link styling. */
  children?: ReactNode;
};

/** The house "Edit"-style text-link button used in section headers and card corners. */
export const EditLinkButton = ({ onClick, isDisabled, children }: Props) => {
  const { t } = useResource();

  return (
    <Button
      variant="text"
      onClick={onClick}
      disabled={isDisabled}
      sx={{
        fontSize: "14px",
        fontWeight: 600,
        color: Colors.Link,
        textTransform: "none",
        minWidth: 0,
        p: 1,
      }}
    >
      {children ?? t(Resources.Common.Edit)}
    </Button>
  );
};
